module.exports = __webpack_public_path__ + "static/media/COPING_MIXED_BOTH.fdc6f6f9.md";